<template>
  <div
    ref="rootElement"
    class="content-color-up-review row justify-content-between"
    :class="{ 'pdf-colorup-review': formatPdf === true }"
    :style="{
      width: formatPdf === true ? `${widthPdf}px` : 'auto',
      height: formatPdf === true ? `${heightPdf}px` : 'auto'
    }"
  >
    <div class="col-md-7 p-0">
      <div
        ref="contentDesign"
        class="content-design p-0 d-flex flex-column justify-content-between"
        :style="{ minHeight: `${hContentDesign}px` }"
      >
        <h1
          v-if="!_get(getterDesignData, 'userObj.isDummy')"
          class="title text-left mb-0 pt-4 pl-5 pr-5 pb-0"
        >
          {{ data.organizationName || 'Adicustom' }}
          <div v-if="data.designName" class="designName">
            {{ data.designName }}
          </div>
        </h1>
        <h1 v-else class="title text-left mb-0 pt-4 pl-5 pr-5 pb-0">
          {{ data.designName }}
        </h1>

        <div
          ref="thumbsColorUpReview"
          class="d-flex align-items-center justify-content-between"
          :class="{ 'position-relative': thumbsRefreshing }"
          :style="{ height: `${hThumbsColorUp}px` }"
        >
          <ThumbsColorUpReview
            v-if="
              hThumbsColorUp > 0 && thumbnails.centerPath && !thumbsRefreshing
            "
            class="ThumbsColorUpReview w-100"
            :thumbnails="thumbnails"
            :sufix-images="sufixImages"
            @onThumbsLoaded="thumbsLoaded = true"
          />
          <BBSectionLoader
            v-if="thumbsRefreshing && !getterLoaderVisible"
            :is-loading="true"
          />
        </div>

        <div
          class="footer-info p-4 d-flex align-items-start justify-content-between"
        >
          <div class="footer-year flex-shrink-1">
            {{ new Date(data.createdAt) | dateFormat('YYYY') }}
          </div>
          <h1 v-if="infoProduct" class="footer-title pl-4 pr-4 text-center">
            {{ infoProduct.styleName }}
            <br />
            <small>{{ infoProduct.styleNumber }}</small>
          </h1>
          <div class="flex-shrink-1 d-flex flex-column text-right">
            <span class="footer-date">{{
              new Date(data.createdAt) | dateFormat('MM.DD.YYYY')
            }}</span>
            <div>
              <router-link :to="{ name: 'home' }">
                <img
                  class="img-fluid mt-3 logo"
                  src="@/assets/images/adidas.custom.logo.white.svg"
                  alt="Adidas Logo"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="colRight" class="col-md-5 col-info pl-5 pr-5 pb-4">
      <slot name="contentTopRight" />
      <InfoColorUpReview
        v-if="stateMaterials"
        :sufix-images="sufixImages"
        :thumbs-refreshing="thumbsRefreshing"
        :style="{
          paddingTop: topRightPadding || (hasContentTopRightSlot ? '80px' : 0)
        }"
        :menu-items="data.menuItemsProduct"
        :state-materials="stateMaterials"
        :format-pdf="formatPdf"
        @onThumbsLoaded="thumbsInfoLoaded = true"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

// import FinalizeColorUpReview from '@/views/frontend/FinalizeColorUpReview'
import InfoColorUpReview from '@/components/Front/finalize/InfoColorUpReview'
import ThumbsColorUpReview from '@/components/Front/finalize/ThumbsColorUpReview'
import BBSectionLoader from '@/components/common/BBSectionLoader'

@Component({
  components: {
    InfoColorUpReview,
    ThumbsColorUpReview,
    BBSectionLoader
  }
})
export default class ContentColorUpReview extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: null
  })
  data

  @Prop({
    type: Object,
    required: true,
    default: null
  })
  thumbnails

  @Prop({
    type: Object,
    required: true,
    default: () => {}
  })
  infoProduct

  @Prop({
    type: Array,
    required: true,
    default: () => []
  })
  stateMaterials

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  formatPdf

  @Prop({
    type: Number,
    required: false,
    default: 0
  })
  topRightPadding

  hThumbsColorUp = 0

  widthPdf = 1944 // window.innerWidth
  heightPdf = 0

  thumbsInfoLoaded = false
  thumbsLoaded = false
  thumbsRefreshing = false
  sufixImages = ''

  mounted() {
    this.heightPdf = this.widthPdf * 0.7727
    this.setDimensions()
  }

  get hContentDesign() {
    return window.innerHeight
  }

  get hasContentTopRightSlot() {
    return !!this.$slots.contentTopRight
  }

  get isThumbsLoaded() {
    return this.thumbsLoaded && this.thumbsInfoLoaded
  }

  @Watch('isThumbsLoaded', { immediate: true })
  onIsThumbsLoaded(newValue) {
    if (newValue === true) {
      this.$emit('onThumbsLoaded')
    }
  }

  startRefreshContent() {
    this.thumbsRefreshing = true
    this.sufixImages = ''
  }

  endRefreshContent() {
    this.thumbsRefreshing = false
    let randomnumber = Math.floor(Math.random() * (1000 - 10 + 1)) + 10
    this.sufixImages = `?r=${randomnumber}`
  }

  setDimensions() {
    this.$nextTick(() => {
      const hColRight = this._get(this.$refs, 'colRight.offsetHeight', 0)
      const hContentDesign =
        hColRight > this.hContentDesign ? hColRight : this.hContentDesign
      /*
        this._get(
          this.$refs,
          'contentDesign.offsetHeight',
          0
        )
      */

      const hRowFirst = this._get(
        this.$refs,
        'contentDesign.firstElementChild.offsetHeight',
        0
      )
      const hRowLast = this._get(
        this.$refs,
        'contentDesign.lastElementChild.offsetHeight',
        0
      )

      this.hThumbsColorUp = hContentDesign - (hRowFirst + hRowLast)

      // console.log('hThumbsColorUp', hContentDesign, hRowFirst, hRowLast)
    })
  }
}
</script>

<style lang="scss" scoped>
.content-color-up-review {
  &.pdf-colorup-review {
    // min-height: 8.5in;
    background-color: $white;
    margin-top: -999em;
    position: relative;
    z-index: 0;
  }
  .logo {
    width: 150px;
  }

  .ThumbsColorUpReview {
    height: 92%;
  }
  .title {
    position: relative;
    .designName {
      font-weight: normal;
      font-size: 13px;
      position: absolute;
      top: 56px;
    }
  }
}
</style>
